import React, { useState } from "react";
import OaLoading from "pages/components/OaLoading";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import WebApi from "api/ApiConstants";
import OaCard from "oahoc/OaCard";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

const TravelCalendar = (props) => {
    const theme = useTheme();
    const history = useHistory();
    const localizer = momentLocalizer(moment);

    const [events, setEvents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const goToEvent = (eventObj) => {
        let state = {from: eventObj.event?.start, to: eventObj.event?.end};
        switch (eventObj?.title) {
            case "Flight": {
                history.push("/admin/travel-calendar-details/flight", state);
                break;
            }
            case "Hotel": {
                break;
            }
            case "Bus": {
                break;
            }
            case "IRCTC PG": {
                break;
            }
        }
    };

    const CustomEvent = (event) => {
        return (
            <span onClick={() => goToEvent(event)}>
                <strong>{event.title} </strong>( <strong>{event.event.count}</strong> )
            </span>
        );
    };
    
    useEffect(() => {
        WebApi.getAgentTravelCalendarData({ date: moment(new Date()).format("YYYY-MM-DD") },
            function (response) {
                // console.log("calendar data " + response.data);
                moment().utcOffset("+05:30").format();
                let appointments = response.data.items;
                if (appointments)
                    for (let i = 0; i < appointments.length; i++) {
                        appointments[i].start = moment
                            .utc(appointments[i].start)
                            .toDate();
                        appointments[i].end = moment.utc(appointments[i].end).toDate();
                    }

                setEvents(appointments);console.log("appointments", appointments)
                setIsLoading(false);
            }, function (error) { console.error("Error", error); setIsLoading(false) }
        );
    }, []);

    return (!isLoading ? 
        <OaCard
            className={"oa-card-primary"}
            style={{ background: theme.palette.primary.darkGray }}
        >
            <GridContainer justifyContent="center">
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardBody calendar>
                            <div style={{ padding: 10 }}>
                                <BigCalendar
                                    localizer={localizer}
                                    events={events}
                                    defaultView="month"
                                    defaultDate={new Date()}
                                    views={["month", "week", "day"]}
                                    components={{
                                        event: CustomEvent,
                                    }}
                                />
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <style>{styles}</style>
        </OaCard>
        :
        <OaLoading />
    );
};

export default TravelCalendar;

const styles = ``;
